import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastService } from '../toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ConfirmationButtonClass,
  ConfirmationDialogData,
} from '@web-frontend/shared/components/confirmation-modal/confirmation-modal.component';
import { ConfirmationModalService } from '@web-frontend/shared/components/confirmation-modal/confirmation-modal.service';
import { StorageService } from '../storage';

const msAssetsUrl = 'assets';
@Injectable({
  providedIn: 'root',
})
export class AssetDownloadService {
  constructor(
    private http: HttpClient,
    private readonly toastService: ToastService,
    private readonly i18n: TranslateService,
    private readonly confirmationModalService: ConfirmationModalService
  ) {}

  data: ConfirmationDialogData = {
    icon: 'assets/icons/ico_check.svg',
    title: 'expense.confirmation.title',
    body: this.i18n.instant('expense.confirmation.text', {
      email: JSON.parse(StorageService.userData)?.email,
    }),
    confirmLabel: 'expense.confirmation.button',
    showCancel: false,
    showCancelX: true,
    confirmClass: ConfirmationButtonClass.primary,
  };

  async requestZip(uris: string[]) {
    if (!uris?.length) {
      this.toastService.show({
        text: this.i18n.instant('downloadAssets.noFiles'),
        type: 'info',
        msDuration: 5000,
      });
      return Promise.resolve();
    }

    const body = {
      uris,
    };

    return this.http
      .post<void>(`:API_BASE_URL${msAssetsUrl}/compressed-files`, body)
      .toPromise()
      .then(() => {
        this.confirmationModalService.open({ data: this.data });
      })
      .catch(() => {
        this.toastService.show({
          text: this.i18n.instant('budget.downloadError'),
          type: 'error',
          msDuration: 5000,
        });
      });
  }
}
